/**
 *
 *
 *
 *
 *
 */
export interface BreakpointOptions {
  /**
 *
 */
  small: MediaQueryList;
  /**
 *
 */
  medium: MediaQueryList;
  /**
 *
 */
  large: MediaQueryList;
  /**
 *
 */
  extraLarge: MediaQueryList;
}

/**
 *
 *
 *
 *
 */
export type BreakpointChangedCallback = (b: Breakpoints) => void;

/**
 *
 *
 *
 *
 *
 */
export type Breakpoints = "s" | "m" | "l" | "xl";

/**
 *
 *
 *
 *
 */
export interface Breakpoint {
  /**
 *
 *
 *
 *
 */
  getBreakpoints(): BreakpointOptions;

  /**
 *
 *
 *
 *
 */
  isSmall(): boolean;

  /**
 *
 *
 *
 *
 */
  isMedium(): boolean;

  /**
 *
 *
 *
 *
 */
  isLarge(): boolean;

  /**
 *
 *
 *
 *
 */
  isExtraLarge(): boolean;

  /**
 *
 *
 *
 *
 *
 */
  getCurrentBreakpoint(): Breakpoints | "unknown";

  /**
 *
 *
 *
 *
 *
 *
 */
  isBreakpointActive(breakpointList: Breakpoints[]): boolean;

  /**
 *
 */
  onBreakpointChanged(callback: BreakpointChangedCallback): void;

  /**
 *
 *
 */
  registerChangeListener: Breakpoint["onBreakpointChanged"];
}

/**
 *
 *
 *
 *
 *
 */
export function breakpoint(
  breakpoints: BreakpointOptions = {
    small: window.matchMedia("(min-width: 0em) and (max-width: 27.99em)"),
    medium: window.matchMedia("(min-width: 28em) and (max-width: 47.99em)"),
    large: window.matchMedia("(min-width: 48em) and (max-width: 61.99em)"),
    extraLarge: window.matchMedia("(min-width: 62em)"),
  },
): Breakpoint {
  const options = {
    s: breakpoints.small,
    m: breakpoints.medium,
    l: breakpoints.large,
    xl: breakpoints.extraLarge,
  } as const;

  const res: Breakpoint = {
    getBreakpoints: () => breakpoints,
    isSmall: () => options.s.matches,
    isMedium: () => options.m.matches,
    isLarge: () => options.l.matches,
    isExtraLarge: () => options.xl.matches,
    getCurrentBreakpoint: () =>
      Object.entries(options).find(([, mq]) => mq.matches)?.[0] ?? "unknown",
    isBreakpointActive: (breakpointList) => breakpointList.includes(res.getCurrentBreakpoint()),
    onBreakpointChanged: (callback) => {
      /*                                                           */
      Object.entries(options).forEach(([k, b]) =>
        typeof b.addEventListener === "function"
          ? b.addEventListener("change", (ev) => {
              if (ev.matches) callback(k);
            })
          : b.addListener((ev) => {
              if (ev.matches) callback(k);
            }),
      );
    },
    registerChangeListener: (cb) => res.onBreakpointChanged(cb),
  };

  return res;
}

export default breakpoint();
